import store from './store/index';

export default (to, from, next) => {
  store.dispatch('users/getMe').then(() => {
    if (!store.getters['users/me']) {
      next({
        path: '/sign-in',
      });
    } else {
      next();
    }
  });
};
